import React, { useState } from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import DialogContent from "@material-ui/core/DialogContent";
import { lensProp, set } from "ramda";
import Grid from "@material-ui/core/Grid";
import { notBlank } from "../../util/ext";
import { useOrganizationPropertyCreate } from "../organizationServices";
import {
  validateProperties,
  validatePropertiesField,
} from "../organizationValidation";
import PropertyComboBox from "./PropertyComboBox";
import PropertyValueComboBox from "./PropertyValueComboBox";
import { useErrorBox } from "./use-errorBox";

const OrganizationPropertyDialog = ({
  organizationId,
  open,
  onCancel,
  onSave,
}) => {
  const [fields, setFields] = useState({ key: null, value: null });

  const {
    addValidationError,
    removeValidationError,
    setValidationErrors,
    setGeneralError,
    hasValidationError,
    firstValidationError,
    ErrorBox: DialogErrors,
  } = useErrorBox();

  const onFieldChange = field => value => {
    const update = set(lensProp(field), value, fields);
    setFields(update);
  };

  const handleBlur = (field, value) => {
    const validationErrors = validatePropertiesField(field, value);
    if (notBlank(validationErrors)) {
      addValidationError(validationErrors);
    } else {
      removeValidationError(field);
    }
  };

  const propertyCreate = useOrganizationPropertyCreate();
  const handleApply = async () => {
    const validationErrors = validateProperties(fields);
    if (notBlank(validationErrors)) {
      setValidationErrors(validationErrors);
    } else {
      try {
        await propertyCreate.mutateAsync({
          resourceIds: { orgId: organizationId, propKey: fields.key },
          data: { value: fields.value },
        });
        onSave();
      } catch (err) {
        setGeneralError(err);
      }
    }
  };

  return (
    <Dialog open={open}>
      <DialogTitle id="form-dialog-title">
        New Organization Property
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Select an existing key and value or create new ones.
        </DialogContentText>
        <DialogErrors />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PropertyComboBox
              value={fields.key}
              onChange={onFieldChange("key")}
              onBlur={() => handleBlur("key", fields.key)}
              error={hasValidationError("key")}
              helperText={firstValidationError("key")}
            />
          </Grid>
          <Grid item xs={12}>
            <PropertyValueComboBox
              value={fields.value}
              propKey={fields.key}
              onChange={onFieldChange("value")}
              onBlur={() => handleBlur("value", fields.value)}
              error={hasValidationError("value")}
              helperText={firstValidationError("value")}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleApply} color="primary">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OrganizationPropertyDialog;
